import DataBinning from "./DataBinning.js";

class FiniteDataBinning extends DataBinning {
    determineBinNr(value, min, max){
        if (value < min) {
            // ignore
            return null;
        }
        else if (value >= max) {
            // ignore
            return null;
        }
        else {
            return super.determineBinNr(value, min, max);
        }
    }
}

export default FiniteDataBinning;